// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1t2DU","disabled":"FileBtn_disabled__23Dep","warn":"FileBtn_warn__1oKk1","fade":"FileBtn_fade__2GT0I"};